import React, { useState, useEffect } from "react";

const LiveTransactions = () => {
  const [transactions, setTransactions] = useState([
    { id: 1, wallet: "Metamask", amount: "+1,250 X1", time: "2 sec ago", status: "success", type: "claim" },
    { id: 2, wallet: "Trust Wallet", amount: "+890 X1", time: "5 sec ago", status: "success", type: "claim" },
    { id: 3, wallet: "Coinbase", amount: "+2,100 X1", time: "12 sec ago", status: "success", type: "claim" },
    { id: 4, wallet: "Ledger", amount: "+1,750 X1", time: "18 sec ago", status: "success", type: "claim" },
  ]);

  useEffect(() => {
    const interval = setInterval(() => {
      const newTransaction = {
        id: transactions.length + 1,
        wallet: ["Phantom", "Binance", "WalletConnect", "Atomic"][Math.floor(Math.random() * 4)],
        amount: `+${Math.floor(Math.random() * 3000) + 500} X1`,
        time: "just now",
        status: "success",
        type: "claim"
      };
      
      setTransactions(prev => [newTransaction, ...prev.slice(0, 7)]);
    }, 3000);

    return () => clearInterval(interval);
  }, [transactions.length]);

  const getStatusColor = (status) => {
    return status === "success" ? "text-white" : "text-red-400";
  };

  const getWalletIcon = (wallet) => {
    const icons = {
      "Metamask": "🦊",
      "Trust Wallet": "🤝", 
      "Coinbase": "🏦",
      "Ledger": "🔒",
      "Phantom": "👻",
      "Binance": "💰",
      "WalletConnect": "🔗",
      "Atomic": "⚛️"
    };
    return icons[wallet] || "👛";
  };

  return (
    <section className="py-16 bg-gradient-to-br from-eco-black to-eco-dark">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-black gradient-text mb-4">
            Live Transactions
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Real-time X1 token claims happening across the network
          </p>
        </div>

        <div className="glass-card rounded-3xl overflow-hidden border border-white/20">
          <div className="bg-gradient-to-r from-white to-gray-300 px-6 py-3 flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-3 h-3 bg-gray-900 rounded-full animate-pulse"></div>
              <span className="text-gray-900 font-bold">LIVE</span>
            </div>
            <div className="text-gray-900 font-medium">
              {transactions.length}+ Transactions
            </div>
          </div>

          <div className="max-h-96 overflow-y-auto">
            {transactions.map((transaction) => (
              <div
                key={transaction.id}
                className="flex items-center justify-between p-6 border-b border-gray-700 border-opacity-50 hover:bg-eco-dark hover:bg-opacity-30 transition-all duration-300 group"
              >
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-white to-gray-300 rounded-xl flex items-center justify-center text-gray-900 text-lg font-bold group-hover:scale-110 transition-transform duration-300">
                    {getWalletIcon(transaction.wallet)}
                  </div>
                  <div>
                    <h4 className="font-semibold text-white group-hover:text-white transition-colors">
                      {transaction.wallet}
                    </h4>
                    <p className="text-sm text-gray-400">{transaction.time}</p>
                  </div>
                </div>
                
                <div className="text-right">
                  <div className={`text-lg font-bold ${getStatusColor(transaction.status)}`}>
                    {transaction.amount}
                  </div>
                  <div className="flex items-center space-x-2 justify-end mt-1">
                    <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                    <span className="text-xs text-gray-400">Confirmed</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="p-6 bg-eco-dark bg-opacity-50 border-t border-gray-700">
            <div className="grid grid-cols-3 gap-4 text-center">
              <div>
                <div className="text-2xl font-black gradient-text">12.4K</div>
                <div className="text-gray-400 text-sm">Total Claims</div>
              </div>
              <div>
                <div className="text-2xl font-black text-white">98.7%</div>
                <div className="text-gray-400 text-sm">Success Rate</div>
              </div>
              <div>
                <div className="text-2xl font-black text-gray-300">2.1s</div>
                <div className="text-gray-400 text-sm">Avg. Speed</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LiveTransactions;